module.exports = __webpack_public_path__ + "media/images/Icon-round-bc956102d4550764450a9a1f8882c206.png";